import { Link } from '@chakra-ui/react';
import styled from 'styled-components';

export const LinkButton = styled(Link)`
  width: 36px;
  height: 36px;

  background-color: white;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  :hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
`;
